import React, { useState, useEffect } from 'react';
import { Modal, Button, Row, Col, Spinner } from 'react-bootstrap';
import { Formik, Form, Field } from 'formik';
import { Input } from 'reactstrap';
import { InputFormFiled } from '../../../components/Common/FormikField/InputFormFiled';
import { GetSchema, user_name } from '../../../js/Base/ValidationSchema';
import toastAlert from '../../../js/Base/ToastAlert';
import CloseIcon from '@mui/icons-material/Close';
import { createCompanyGroup } from '../../../api/companyApi';

const CreateOrgModal = ({ groupsList, isModalOpen, handleClose, submitEffect }) => {
  const [initialValues, setInitialValues] = useState({
    orgName: '', parentOrg: '',
  });

  const formSchema = GetSchema({
    orgName: user_name(),
    parentOrg: user_name(),
  });

  const resetForm = () => {
    setInitialValues({
      orgName: '', parentOrg: '',
    });
  };

  const handleSubmit = async (values, { setSubmitting, setErrors }) => {
    try {
      const companyUuid = localStorage.getItem("company_uuid");
      const payload = {
        company_uuid: companyUuid,
        name: values.orgName,
        parent_uuid: values.parentOrg || null,
      };
  
      await createCompanyGroup(payload);
      toastAlert.autoClose(true).showSuccess("新增成功");
      submitEffect();
    } catch (error) {
      if (error.__handled) return;
      toastAlert.autoClose(true).showError('新增失敗');
    } finally {
      setSubmitting(false);
      handleClose();
    }
  };

  return (
    <>
      <Modal
        animation="true"
        style={{ zIndex: '1299' }}
        show={isModalOpen}
        onHide={handleClose}
        className="CompOrgManagement ListBlock"
      >
        <Modal.Header>
          <Modal.Title className="modal-title">新增組織</Modal.Title>
        
          {/* 解決籃框問題，自訂MUI按鈕 */}
          <button
            onClick={handleClose}
            style={{
              background: 'transparent',
              border: 'none',
              cursor: 'pointer',
              padding: 0,
              marginLeft: 'auto'
            }}
          >
            <CloseIcon fontSize="medium" />
          </button>
        </Modal.Header>
        <Formik
          initialValues={initialValues}
          onSubmit={handleSubmit}
          validationSchema={formSchema}
          enableReinitialize={true}
        >
          {({ handleSubmit, resetForm, setFieldValue, isSubmitting, errors, touched, values }) => (
            <Form className="form" style={{ padding:'0px' }}>
              <Modal.Body className="modal-body" style={{ paddingTop:'0px' }}>
                <Row>
                  <Col md="12">
                    <InputFormFiled
                      title="組織名稱"
                      className="input-field custom-select"
                      name="orgName"
                      type="text"
                      invalid={errors.name && touched.name}
                    />
                  </Col>
                  <Col md="12">
                    <InputFormFiled
                      title="上層組織"
                      name="parentOrg"
                      type="select"
                      options={
                        groupsList && groupsList.length > 0
                          ? groupsList.map(g => ({
                              uuid: g.uuid,
                              name: g.name,
                            }))
                          : []
                      }
                      invalid={errors.parentOrg && touched.parentOrg}
                    />
                  </Col>
                </Row>
              </Modal.Body>
              <Modal.Footer className="modal-footer">
                <Button
                  type="button"
                  className="btn btn-cancel"
                  onClick={handleClose}
                  disabled={isSubmitting}
                >
                  取消
                </Button>
                <Button type="submit" className="btn btn-custom" disabled={isSubmitting}>
                  確認
                </Button>
              </Modal.Footer>
            </Form>
          )}
      </Formik>
      </Modal>
    </>
  );
};

export default CreateOrgModal;
